export default function Wstep(props) {
	return <span id="a11y-wstep">{props.children}</span>;
}
